/* src/app/features/honra/solicitacao-honra/solicitacao-honra-detalhe.component.scss */
.moeda {
  text-align: right;
}
/*# sourceMappingURL=solicitacao-honra-detalhe.component.css.map */
